import AddIcon from "@mui/icons-material/Add";
import { Box } from "@mui/material";
import Fab from "@mui/material/Fab";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createPendingUser,
  getProviderUsers,
  getUserRoles
} from "../../../actions/users";
import EditUserDialog from "../../commons/dialog/editUserDialog";
import ProviderUserTable from "./providerUserTable";

const initialUser = {
  nombre: "",
  apellido: "",
  email: "",
  idRol: "",
  idArt: "",
  prestadores: [],
  referenteGestor: null,
};

const ProviderUserTableContainer = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const users = useSelector((state) => state.users.getProviderUsers);
  const loading = useSelector((state) => state.users.getProviderUsers.isFetching);
  const selectedProvider = useSelector((state) => state.providers.selectedProvider);
  const [openEdit, setOpenEdit] = useState(false);
  const [user, setUser] = useState(initialUser);
  const [addingNewUser, setAddingNewUser] = useState(true);

  useEffect(() => {
    if (selectedProvider && typeof selectedProvider !== "boolean") {
      dispatch(getProviderUsers(selectedProvider));
    }
    setUser({ ...initialUser, prestadores: [selectedProvider] });
  }, [selectedProvider, dispatch]);

  const handleCloseEdit = () => {
    setUser({ ...initialUser, prestadores: [selectedProvider] });
    setAddingNewUser(true);
    setOpenEdit(false);
  };

  const handleSubmitUser = (user, isNew) => {
    if (isNew) {
      dispatch(createPendingUser(user)).then(() => {
        enqueueSnackbar(<p>Se ha creado el usuario correctamente!</p>, {
          variant: "success",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        });
        dispatch(getProviderUsers(selectedProvider));
      });
    } else {
      //TODO: Actualizo usuario
    }
    handleCloseEdit();
  };

  const handleOpenEdit = () => {
    dispatch(getUserRoles());
    setOpenEdit(true);
  };

  return (
    <div>
      <ProviderUserTable
        data={users.data}
        loading={loading}
        title="Usuarios"
        fetchData={() => dispatch(getProviderUsers(selectedProvider))}
      />

      {
        <Box
          sx={{
            margin: "5px 20px",
            display: "flex",
            justifyContent: "flex-end",
          }}>
          <Fab
            onClick={handleOpenEdit}
            disabled={loading}
            color="primary"
            aria-label="add">
            <AddIcon />
          </Fab>
        </Box>
      }

      <EditUserDialog
        user={user}
        open={openEdit}
        handleClose={handleCloseEdit}
        addingNewUser={addingNewUser}
        handleSubmit={handleSubmitUser}
        availableRoles={["Prestador administrativo"]}
      />

    </div>
  );
};

export default ProviderUserTableContainer;
